import { RoundedButton } from '@/src/components/Button'
import LocalizedLink from '@/src/components/LocalizedLink'
import { Heading } from '@/src/components/Typography'
import { FamilyType } from '@/src/services/types/games'
import { useTranslation } from 'react-i18next'

type SplashCardProps = {
  gameFamily: FamilyType
  playDemoHandler?: () => void
  providername?: string | undefined
  hideDemoUrl?: boolean
}

export default function SplashCard({
  gameFamily,
  playDemoHandler,
  providername,
  hideDemoUrl,
}: SplashCardProps) {
  const { t } = useTranslation(['game'])
  return (
    <div className='absolute top-0 z-20 flex h-screen w-screen items-center justify-center text-center'>
      <div className='flex w-full flex-col items-center justify-center'>
        <div className='w-full max-w-[18rem] rounded-xl bg-primary px-3 py-5'>
          <div className='mx-auto w-full'>
            <Heading level={1}>{gameFamily.familyName}</Heading>
          </div>
          <div className='mx-auto w-full'>
            <Heading className='opacity-60' level={3}>
              {providername}
            </Heading>
          </div>
          {playDemoHandler && !hideDemoUrl && (
            <RoundedButton
              onClick={() => playDemoHandler()}
              size='default'
              className='w-48'
            >
              {t('play-demo')}
            </RoundedButton>
          )}
          <LocalizedLink href='/pnp/deposit' className='mx-auto w-full'>
            <RoundedButton
              size='default'
              type='secondary'
              className='mt-2 w-48'
            >
              {t('sign-in-play')}
            </RoundedButton>
          </LocalizedLink>
        </div>
      </div>
    </div>
  )
}
